/* eslint-disable */
import settings from "../../../configs/settings";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Add } from "@mui/icons-material";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import AnteojoAnteojo from "./AnteojoAnteojo";
import AnteojoCristales from "./AnteojoCristales";
import AnteojoTratamientos from "./AnteojoTratamientos";
import AnteojoObservaciones from "./AnteojoObservaciones";
import AnteojoTable from "./AnteojoTable";
import { useContext, useState } from "react";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
import Message from "../../../project/utils/Message";
import { formatMoney } from "../../utils/utils"

//
// ################################################################################
//
const Anteojo = () => {
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);

  const {
    anteojoTabNuevoDeCliente,
    expandedAccordionAnteojo,
    setExpandedAccordionAnteojo,
    disabledAccordionAnteojo,
    expandedAccordionAnteojoAnteojo,
    setExpandedAccordionAnteojoAnteojo,
    expandedAccordionAnteojoCristales,
    setExpandedAccordionAnteojoCristales,
    expandedAccordionAnteojoTratamientos,
    setExpandedAccordionAnteojoTratamientos,
    expandedAccordionAnteojoObservaciones,
    setExpandedAccordionAnteojoObservaciones,
    anteojoArmazonNuevo,
    anteojoArmazonCliente,
    anteojoCristales,
    totalAnteojoTratamientos,
    totalAnteojoTratamientosContado,
    anteojoAction,
    limpiaAnteojo,
    guardarAnteojoEnTablaAnteojos,
    totalAnteojo,
    totalAnteojoContado,
    gaAction,
  } = useContext(GestionAtencionContext);
  //
  // ################################################################################
  //
  const handleClickGuardarAnteojo = () => {
    // valido los datos necesarios del anteojo antes de agregarlo a la tabla de anteojos

    // --------------------------------------------------------------------------------------
    // valido los datos de los cristales del anteojo

    if (anteojoCristales.anteojoCristalesTipoAnteojo === "") {
      // si el usuario no selecciono el tipo de anteojo
      setMessage({
        messageText: "Debes seleccionar un tipo de anteojo para los cristales",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (
      !anteojoCristales.anteojoCristalesSelectedCristalOD &&
      !anteojoCristales.anteojoCristalesSelectedCristalOI
    ) {
      // si el usuario no selecciono ningun cristal
      setMessage({
        messageText: "Debes seleccionar cristales para uno o ambos ojos",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (
      anteojoCristales.anteojoCristalesDistanciaPupilarOD === "" ||
      anteojoCristales.anteojoCristalesDistanciaPupilarOI === "" ||
      anteojoCristales.anteojoCristalesAlturaPupilarOD === "" ||
      anteojoCristales.anteojoCristalesAlturaPupilarOI === "" ||
      anteojoCristales.anteojoCristalesAlturaParpadoInferiorOD === "" ||
      anteojoCristales.anteojoCristalesAlturaParpadoInferiorOI === "" ||
      isNaN(anteojoCristales.anteojoCristalesDistanciaPupilarOD) ||
      isNaN(anteojoCristales.anteojoCristalesDistanciaPupilarOI) ||
      isNaN(anteojoCristales.anteojoCristalesAlturaPupilarOD) ||
      isNaN(anteojoCristales.anteojoCristalesAlturaPupilarOI) ||
      isNaN(anteojoCristales.anteojoCristalesAlturaParpadoInferiorOD) ||
      isNaN(anteojoCristales.anteojoCristalesAlturaParpadoInferiorOI)
    ) {
      // si el valor de alguna de las distancias no es correcto
      setMessage({
        messageText: "Debes indicar valores correctos en las medidas de cristales",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    anteojoCristales.anteojoCristalesDistanciaPupilarOD = parseInt(
      +anteojoCristales.anteojoCristalesDistanciaPupilarOD
    );
    anteojoCristales.anteojoCristalesDistanciaPupilarOI = parseInt(
      +anteojoCristales.anteojoCristalesDistanciaPupilarOI
    );
    anteojoCristales.anteojoCristalesAlturaPupilarOD = parseInt(
      +anteojoCristales.anteojoCristalesAlturaPupilarOD
    );
    anteojoCristales.anteojoCristalesAlturaPupilarOI = parseInt(
      +anteojoCristales.anteojoCristalesAlturaPupilarOI
    );
    anteojoCristales.anteojoCristalesAlturaParpadoInferiorOD = parseInt(
      +anteojoCristales.anteojoCristalesAlturaParpadoInferiorOD
    );
    anteojoCristales.anteojoCristalesAlturaParpadoInferiorOI = parseInt(
      +anteojoCristales.anteojoCristalesAlturaParpadoInferiorOI
    );

    if (
      anteojoCristales.anteojoCristalesDistanciaPupilarOD < 0 ||
      anteojoCristales.anteojoCristalesDistanciaPupilarOI < 0 ||
      anteojoCristales.anteojoCristalesAlturaPupilarOD < 0 ||
      anteojoCristales.anteojoCristalesAlturaPupilarOI < 0 ||
      anteojoCristales.anteojoCristalesAlturaParpadoInferiorOD < 0 ||
      anteojoCristales.anteojoCristalesAlturaParpadoInferiorOI < 0
    ) {
      // si el valor de alguna de las distancias es menor a 0
      setMessage({
        messageText: "Debes indicar valores correctos en las medidas del anteojo del Cliente",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    // --------------------------------------------------------------------------------------
    // valido los datos del anteojo nuevo o del cliente

    if (anteojoTabNuevoDeCliente === 0) {
      // si el tab activo de anteojos es el de anteojos nuevos

      if (anteojoArmazonNuevo.anteojoArmazonNuevoCodigoArmazon === "") {
        // si el usuario no selecciono un anteojo nuevo
        setMessage({
          messageText: "Debes registrar un armazón o anteojo de sol",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }
    } else {
      // si el tab activo de anteojos es el de anteojo del cliente

      if (!anteojoArmazonCliente.anteojoArmazonClienteDejaSuAnteojo) {
        // si el cliente no deja su anteojo

        if (anteojoArmazonCliente.anteojoArmazonClienteDescripcion === "") {
          // si el usuario no indico datos del anteojo del cliente
          setMessage({
            messageText: "Debes registrar el estado de la montura del Cliente",
            severity: "error",
          });
          setShowMessage(true);
          return;
        }

        if (
          anteojoArmazonCliente.anteojoArmazonClienteDistanciaHorizontal === "" ||
          anteojoArmazonCliente.anteojoArmazonClienteDistanciaVertical === "" ||
          anteojoArmazonCliente.anteojoArmazonClienteDistanciaDiagonal === "" ||
          anteojoArmazonCliente.anteojoArmazonClienteDistanciaPuente === "" ||
          anteojoArmazonCliente.anteojoArmazonClienteDistanciaMayor === "" ||
          isNaN(anteojoArmazonCliente.anteojoArmazonClienteDistanciaHorizontal) ||
          isNaN(anteojoArmazonCliente.anteojoArmazonClienteDistanciaVertical) ||
          isNaN(anteojoArmazonCliente.anteojoArmazonClienteDistanciaDiagonal) ||
          isNaN(anteojoArmazonCliente.anteojoArmazonClienteDistanciaPuente) ||
          isNaN(anteojoArmazonCliente.anteojoArmazonClienteDistanciaMayor)
        ) {
          // si el valor de alguna de las distancias no es correcto
          setMessage({
            messageText: "Debes indicar valores correctos en las medidas de la montura del Cliente",
            severity: "error",
          });
          setShowMessage(true);
          return;
        }

        anteojoArmazonCliente.anteojoArmazonClienteDistanciaHorizontal = parseInt(
          +anteojoArmazonCliente.anteojoArmazonClienteDistanciaHorizontal
        );
        anteojoArmazonCliente.anteojoArmazonClienteDistanciaVertical = parseInt(
          +anteojoArmazonCliente.anteojoArmazonClienteDistanciaVertical
        );
        anteojoArmazonCliente.anteojoArmazonClienteDistanciaDiagonal = parseInt(
          +anteojoArmazonCliente.anteojoArmazonClienteDistanciaDiagonal
        );
        anteojoArmazonCliente.anteojoArmazonClienteDistanciaPuente = parseInt(
          +anteojoArmazonCliente.anteojoArmazonClienteDistanciaPuente
        );
        anteojoArmazonCliente.anteojoArmazonClienteDistanciaMayor = parseInt(
          +anteojoArmazonCliente.anteojoArmazonClienteDistanciaMayor
        );

        if (
          anteojoArmazonCliente.anteojoArmazonClienteDistanciaHorizontal < 0 ||
          anteojoArmazonCliente.anteojoArmazonClienteDistanciaVertical < 0 ||
          anteojoArmazonCliente.anteojoArmazonClienteDistanciaDiagonal < 0 ||
          anteojoArmazonCliente.anteojoArmazonClienteDistanciaPuente < 0 ||
          anteojoArmazonCliente.anteojoArmazonClienteDistanciaMayor < 0
        ) {
          // si el valor de alguna de las distancias es menor a 0
          setMessage({
            messageText: "Debes indicar valores correctos en las medidas de la montura del Cliente",
            severity: "error",
          });
          setShowMessage(true);
          return;
        }

        if (anteojoArmazonCliente.anteojoArmazonClientePerfil === "") {
          // si no se ha seleccionado un perfil
          setMessage({
            messageText: "Debes seleccionar el perfil de la montura del Cliente",
            severity: "error",
          });
          setShowMessage(true);
          return;
        }

        if (anteojoArmazonCliente.anteojoArmazonClienteCaracteristica === "") {
          // si no se ha seleccionado una caracteristica
          setMessage({
            messageText: "Debes seleccionar la caracteristica de la montura del Cliente",
            severity: "error",
          });
          setShowMessage(true);
          return;
        }
      }
    }

    // si no hay errores agrego el anteojo a la tabla de anteojos

    guardarAnteojoEnTablaAnteojos();
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Box>
        <Paper elevation={3} sx={{ m: 1, p: 2 }}>
          <Accordion
            expanded={expandedAccordionAnteojo}
            disabled={disabledAccordionAnteojo}
            onChange={() => setExpandedAccordionAnteojo(!expandedAccordionAnteojo)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="anteojo"
            >
              <Typography>Anteojo {anteojoAction.codigoAnteojo}</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ borderTop: "1px solid rgba(0, 0, 0, .125)" }}>
              {/* Cristales */}
              <Accordion
                expanded={expandedAccordionAnteojoCristales}
                onChange={() =>
                  setExpandedAccordionAnteojoCristales(!expandedAccordionAnteojoCristales)
                }
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="cristales"
                >
                  <Typography component={"span"} variant={"body1"}>
                    Cristales
                    {anteojoCristales.anteojoCristalesPrecioVentaCristalOD +
                      anteojoCristales.anteojoCristalesPrecioVentaCristalOI !==
                      0 &&
                      !expandedAccordionAnteojoCristales && (
                        <>
                          <Box
                            sx={{
                              textAlign: "left",
                            }}
                          >
                            Precio de lista:
                            <b>
                              {(
                                anteojoCristales.anteojoCristalesPrecioVentaCristalOD +
                                anteojoCristales.anteojoCristalesPrecioVentaCristalOI
                              ).toLocaleString(
                                settings.numericLocales.language,
                                settings.numericLocales.options
                              )}
                            </b>
                            Precio de contado:
                            <b>
                              {(
                                anteojoCristales.anteojoCristalesPrecioVentaContadoCristalOD +
                                anteojoCristales.anteojoCristalesPrecioVentaContadoCristalOI
                              ).toLocaleString(
                                settings.numericLocales.language,
                                settings.numericLocales.options
                              )}
                            </b>
                          </Box>
                        </>
                      )}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ borderTop: "1px solid rgba(0, 0, 0, .125)" }}>
                  {/* Cristales OD, OI */}
                  <AnteojoCristales />
                </AccordionDetails>
              </Accordion>

              {/* Armazon / Anteojo de sol */}
              <Accordion
                expanded={expandedAccordionAnteojoAnteojo}
                onChange={() =>
                  setExpandedAccordionAnteojoAnteojo(!expandedAccordionAnteojoAnteojo)
                }
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="armazon"
                >
                  <Typography component={"span"} variant={"body1"}>
                    Armazón / Anteojo de Sol
                    {anteojoArmazonNuevo.anteojoArmazonNuevoPrecioVentaArmazon !== 0 &&
                      !expandedAccordionAnteojoAnteojo && (
                        <>
                          <Box
                            sx={{
                              textAlign: "left",
                            }}
                          >
                            Precio de lista:
                            <b>
                              {anteojoArmazonNuevo.anteojoArmazonNuevoPrecioVentaArmazon.toLocaleString(
                                settings.numericLocales.language,
                                settings.numericLocales.options
                              )}
                            </b>
                            Precio de contado:
                            <b>
                              {anteojoArmazonNuevo.anteojoArmazonNuevoPrecioVentaContadoArmazon.toLocaleString(
                                settings.numericLocales.language,
                                settings.numericLocales.options
                              )}
                            </b>
                          </Box>
                        </>
                      )}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ borderTop: "1px solid rgba(0, 0, 0, .125)" }}>
                  {/* Anteojo nuevo o del cliente */}
                  <AnteojoAnteojo />
                </AccordionDetails>
              </Accordion>

              {/* Tratamientos */}
              <Accordion
                expanded={expandedAccordionAnteojoTratamientos}
                onChange={() =>
                  setExpandedAccordionAnteojoTratamientos(!expandedAccordionAnteojoTratamientos)
                }
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="tratamientos"
                >
                  <Typography component={"span"} variant={"body1"}>
                    Tratamientos
                    {totalAnteojoTratamientos !== 0 && !expandedAccordionAnteojoTratamientos && (
                      <>
                        <Box
                          sx={{
                            textAlign: "left",
                          }}
                        >
                          Precio de lista:
                          <b>
                            {totalAnteojoTratamientos.toLocaleString(
                              settings.numericLocales.language,
                              settings.numericLocales.options
                            )}
                          </b>
                          Precio de contado:
                          <b>
                            {totalAnteojoTratamientosContado.toLocaleString(
                              settings.numericLocales.language,
                              settings.numericLocales.options
                            )}
                          </b>
                        </Box>
                      </>
                    )}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ borderTop: "1px solid rgba(0, 0, 0, .125)" }}>
                  {/* Tratamientos */}
                  <AnteojoTratamientos />
                </AccordionDetails>
              </Accordion>

              {/* Notas y observaciones */}
              <Accordion
                expanded={expandedAccordionAnteojoObservaciones}
                onChange={() =>
                  setExpandedAccordionAnteojoObservaciones(!expandedAccordionAnteojoObservaciones)
                }
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="observaciones"
                >
                  <Typography>Notas y observaciones</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ borderTop: "1px solid rgba(0, 0, 0, .125)" }}>
                  {/* Observaciones */}
                  <AnteojoObservaciones />
                </AccordionDetails>
              </Accordion>
            </AccordionDetails>

            <Grid container spacing={1}>
              <Grid item sm={6}>
                <Typography
                  component="div"
                  align="right"
                  sx={{
                    p: 1,
                    ml: 2,
                    backgroundColor: "SteelBlue",
                    borderRadius: "5px",
                    fontSize: "1rem",
                    fontWeight: "bold",
                  }}
                >
                  TOTAL DE LISTA: {formatMoney(totalAnteojo)}
                </Typography>
              </Grid>
              <Grid item sm={6}>
                <Typography
                  component="div"
                  align="right"
                  sx={{
                    p: 1,
                    ml: 2,
                    backgroundColor: "SteelBlue",
                    borderRadius: "5px",
                    fontSize: "1rem",
                    fontWeight: "bold",
                  }}
                >
                  TOTAL DE CONTADO: {formatMoney(totalAnteojoContado)}
                </Typography>
              </Grid>
            </Grid>

            <Box sx={{ p: 2 }}>
              {gaAction.cu !== "view" && (
                <>
                  {/* boton de agregar / actualizar anteojo */}

                  <Button
                    sx={{ mr: 1 }}
                    variant="contained"
                    onClick={handleClickGuardarAnteojo}
                    startIcon={anteojoAction.cu === "new" ? <Add /> : <EditIcon />}
                  >
                    {anteojoAction.cu === "new" ? "Agregar" : "Actualizar"} Anteojo
                  </Button>
                </>
              )}

              {/* boton de cancelar / cerrar */}

              <Button
                sx={{ mr: 1 }}
                variant="outlined"
                onClick={limpiaAnteojo}
                startIcon={<CancelIcon />}
              >
                {gaAction.cu !== "view" ? "Cancelar" : "Cerrar"}
              </Button>
            </Box>
          </Accordion>
        </Paper>
      </Box>

      <AnteojoTable />

      {/* >>>> Messages */}

      {showMessage && (
        <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
      )}
    </>
  );
};

export default Anteojo;
